'use strict';
const Flights = require('od-apps/app.flights');
const BuyPathResults = function(resultPage, dynpackBuyPath, flightsBuyPath) {
    this.resultPage = resultPage;
    this.dynpackBuyPath = dynpackBuyPath;
    this.flightsBuyPath = flightsBuyPath;
};
BuyPathResults.prototype.build = function() {
    return Flights.isDynpackFlightsResults(this.resultPage) || Flights.isAccommodationResults(this.resultPage)
        ? this.dynpackBuyPath
        : this.flightsBuyPath;
};
module.exports = BuyPathResults;

